import { Collapsible } from '@ui/animated/Collapsible'
import { DeviceProviderSchema, PaymentMethod } from '@ca/common'
import FormSelect from '@ui/forms/Select/FormSelect'
import { resolveProvider } from '@order/hooks/usePaymentMethods'
import { trpc } from 'api'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { PaymentFormControl } from './usePaymentForm'
import AppConfig from 'config'
import Line from '@ui/elements/Line'

const ReaderSelect = ({
  method,
  control,
}: {
  method?: PaymentMethod
  control: PaymentFormControl
}) => {
  const provider = DeviceProviderSchema.parse(resolveProvider('terminal'))
  const devices = trpc.order.payments.devices.useQuery({ provider })
  const { t } = useTranslation(['types'])

  const optionsDevices = useMemo(() => {
    const defaultDevice = devices.data?.find(
      (device) => device.client_device_id === AppConfig.serialNumber
    )

    // For now if we have a default device, we don't allow any other devices
    if (defaultDevice) {
      return [
        {
          value: defaultDevice.reader_id,
          label:
            defaultDevice.reader_name ||
            defaultDevice.reader_serial_number ||
            'Default',
        },
      ]
    }
    return (
      devices.data?.map((device) => ({
        value: device.reader_id,
        label: device.reader_name || device.reader_serial_number || 'unknown',
      })) || [
        {
          value: null,
          label: 'Default',
        },
      ]
    )
  }, [devices.data])

  const open = method === 'terminal' && optionsDevices.length > 1

  return (
    <Collapsible fullWidth config={{ mass: 0.5 }} open={open}>
      <View className="flex flex-col gap-8 pt-8">
        <Line />
        <View className="px-8">
          <FormSelect
            name="reader_id"
            control={control}
            options={optionsDevices}
            label={t('types:payment.method.terminal')}
          />
        </View>
      </View>
    </Collapsible>
  )
}

export default ReaderSelect
